import React from 'react';
import logo from './OCV_Apps.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} style={{width: "75vw"}} alt="logo" />
        <a
          className="App-link"
          href="https://www.ocvapps.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit OCVApps
        </a>
      </header>
    </div>
  );
}

export default App;